// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1cXBh","title":"AfterFrontImage_title__t-KT1"};